import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-exclusions-cuscatlan',
  templateUrl: './exclusions-cuscatlan.component.html',
  styleUrls: ['./exclusions-cuscatlan.component.scss']
})
export class ExclusionsCuscatlanComponent implements OnInit {

  public show: boolean;
  public show_mobile: boolean;
  public show_description: boolean;

  languaje: string;

  @Input() show_content: boolean;
  @Input() is_active: boolean;
  @Output() x = new EventEmitter();

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      let lang: string = params['lang'];
      if (lang) {
        if (lang.toLowerCase() === 'en') {
          this.languaje = 'en';
          sessionStorage.setItem('lang', lang);
        } else {
          this.languaje = params['lang'];
          sessionStorage.setItem('lang', lang);
        }
      } 
    });
  }

  ngOnInit(): void {
    let lang = sessionStorage.getItem('lang');
    this.languaje = lang.toLowerCase();
  }

  showContent() {
    this.x.emit({})
  }

  showMobileContent() {
    this.show_mobile = !this.show_mobile;
  }

  toggleClass(number: any) {
    this["show_description" + number] = !this["show_description" + number];
  }

}
